import { IOrderTypeUseCase, IOrderType, IOrderTypeTemplate } from "@lib";
import { IOrderTypeCreateDto, IOrderTypeUpdateDto } from "@lib";
import { DataLoadException } from "@/core/exceptions";
import { Api } from "../axios";

export class OrderTypeUseCase implements IOrderTypeUseCase {
    public async select(companyId: string): Promise<IOrderType[]> {
        try {
            const response = await Api.get<IOrderType[]>(`/companies/${companyId}/lists/ordertypes`);
            return response.data;
        } catch (e: any) {
            throw new DataLoadException(e);
        }
    }

    public async selectTemplates(companyId: string): Promise<IOrderTypeTemplate[]> {
        try {
            const response = await Api.get<IOrderTypeTemplate[]>(`/companies/${companyId}/lists/ordertypes/templates`);
            return response.data;
        } catch (e: any) {
            throw new DataLoadException(e);
        }
    }

    public async get(companyId: string, id: string): Promise<IOrderType> {
        try {
            const response = await Api.get<IOrderType>(`/companies/${companyId}/lists/ordertypes/${id}`);
            return response.data;
        } catch (e: any) {
            throw new DataLoadException(e);
        }
    }

    public async create(companyId: string, dto: IOrderTypeCreateDto): Promise<IOrderType> {
        try {
            const response = await Api.post<IOrderType>(`/companies/${companyId}/lists/ordertypes`, dto);
            return response.data;
        } catch (e: any) {
            throw new DataLoadException(e);
        }
    }

    public async createMany(companyId: string, dtos: IOrderTypeCreateDto[]): Promise<IOrderType[]> {
        try {
            const response = await Api.post<IOrderType[]>(`/companies/${companyId}/lists/ordertypes/many`, dtos);
            return response.data;
        } catch (e: any) {
            throw new DataLoadException(e);
        }
    }

    public async update(companyId: string, id: string, dto: IOrderTypeUpdateDto): Promise<IOrderType> {
        try {
            const response = await Api.put<IOrderType>(`/companies/${companyId}/lists/ordertypes/${id}`, dto);
            return response.data;
        } catch (e: any) {
            throw new DataLoadException(e);
        }
    }

    public async archive(companyId: string, id: string): Promise<void> {
        try {
            await Api.delete<void>(`/companies/${companyId}/lists/ordertypes/${id}`);
        } catch (e: any) {
            throw new DataLoadException(e);
        }
    }
}
